import { Grid, SxProps } from '@mui/material';
import { ReactNode } from 'react';
import { Text } from '../../shared/uiComponents';
import { pageHeaderIconStyles, pageHeaderInContainerStyles, pageHeaderStyles, pageHeaderText } from './styles';

interface PageHeaderProps {
	customStyles?: SxProps;
	headerContent?: ReactNode;
	icon: ReactNode;
	isInContainer?: boolean;
	title: string;
}

export const PageHeader = ({ customStyles, isInContainer, headerContent, icon, title }: PageHeaderProps) => (
	<Grid
		sx={{
			...(isInContainer ? pageHeaderInContainerStyles : pageHeaderStyles),
			...customStyles,
		}}
	>
		<div style={{ display: 'flex', alignItems: 'center' }}>
			<div style={pageHeaderIconStyles}>{icon}</div>
			<Text title={title} font="header" fontWeight="bold" style={pageHeaderText} />
		</div>
		<div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>{headerContent ?? null}</div>
	</Grid>
);
